import { gql } from 'graphql-request'

export namespace CommentMutations {
  export function createComment() {
    return gql`
      mutation createComment($comment: CommentMutation!, $attachments: [Upload!]) {
        createComment(comment: $comment, attachments: $attachments) {
          id
        }
      }
    `
  }
}
